import autoComplete from '@tarekraafat/autocomplete.js'
import { DOMUtils, Container } from '@atypon/ui-utils';

// please note that the Base class is not used here as it doesn't share much but may result in some potential bugs
class AutoCompleteTags extends autoComplete {
    protected preselectedItems: { label: string, value: string }[];
    protected badgeCloseIcon:string = `<i class="autoComplete__tag__icon"></i>`;
    protected onTagRemoved: Function;
    protected tagClasses: Array<string>;

    tagValues: Array<[HTMLInputElement, HTMLElement]>;
    tagsPosition: HTMLElement;

    get field() {
        return this.inputField;
    }

    get values() {
        return this.tagValues.map(([input])=>{
            return input.value;
        });
    }

    protected valueExists(value:string):boolean {
        return this.values.findIndex(item=>item === value) > -1;
    }


    constructor(protected config, protected inputField: HTMLInputElement) {
        super(config);
        const domUtils = Container.get(DOMUtils);
        const input = typeof config.selector === 'function' ? config.selector() : domUtils.getElement(config.selector);
        this.tagsPosition = config.tagsPosition || input;
        this.preselectedItems = config.preselectedItems || [];
        this.tagValues = [];

        if (typeof config.onTagRemoved === 'function') {
            this.onTagRemoved = config.onTagRemoved
        }
        this.tagClasses = config.tagClasses || ['autoComplete__tag']
        this.checkSetPreselected();
    }

    checkSetPreselected(): void {
        this.preselectedItems.map(({ label, value }) => {
            this.createTagValue(label, value);
        });
    }

    buildInput(mainInput: HTMLInputElement, value: string): HTMLInputElement {
        if (!mainInput) {
            return;
        }
        let inputNode = `<input type="hidden" name="${mainInput.name}[]" value="${value}"/>`;
        const fragment = document.createElement('div');
        fragment.innerHTML = inputNode;
        return fragment.firstChild as HTMLInputElement;
    }

    getValues(): Array<[ChildNode, HTMLElement]> {
        return this.tagValues;
    }

    removeAllTags(): void {
        this.tagValues.forEach(([input, tag]) => {
            input.parentNode.removeChild(input);
            tag.parentNode.removeChild(tag);
        });
        this.tagValues = [];
        if (this.onTagRemoved) {
            this.onTagRemoved();
        }
    }

    createTagValue(label: string, value: string): void {
        if(this.valueExists(value)) {
            return;
        }
        const item = this.inputField;
        const input = this.buildInput(item, value);
        const tag = this.buildTag(label, input);
        this.tagValues.push([input, tag]);
        if (this.config.tagsPosition) {
            this.tagsPosition.appendChild(tag);
        } else {
            this.tagsPosition.parentNode.insertBefore(tag, this.tagsPosition);
        }
        item.parentElement?.insertBefore(input, item);
    }


    buildTag(text: string, input: ChildNode): HTMLElement {
        const tag = document.createElement('span');
        tag.innerHTML = `<span>${text}</span>`;
        const off = document.createElement('a');
        off.innerHTML = this.badgeCloseIcon;
        off.href = '#';
        off.addEventListener('click', (e) => {
            e.preventDefault();
            input.parentNode.removeChild(input);
            tag.parentNode.removeChild(tag);
            this.tagValues = this.tagValues.filter(([inputStored, tagStored]) => {
                return!(input === inputStored && tag === tagStored)
            });
            if (this.onTagRemoved) {
                this.onTagRemoved();
            }
        });
        tag.appendChild(off);
        tag.classList.add(...this.tagClasses);
        return tag;
    }
}




export default AutoCompleteTags;

